import { Image } from "./image";
import { useEffect } from "react";

import GLightbox from "glightbox";
import "glightbox/dist/css/glightbox.css";

export const Gallery = (props) => {
  useEffect(() => {
    if (!props.data) return;

    const lightbox = GLightbox({
      selector: ".glightbox",

      /* Navegação */
      touchNavigation: true,
      keyboardNavigation: true,
      draggable: true,
      loop: true,

      /* Comportamento */
      slideEffect: "slide",
      closeOnOutsideClick: true,
      closeOnSlideClick: false,
      openEffect: "zoom",
      closeEffect: "zoom",

      /* Mobile fixes */
      zoomable: false,
      autofocusVideos: false,

      /* UI */
      moreLength: 0,

      /* Acessibilidade – correção definitiva do aria-hidden */
      onOpen: () => {
        requestAnimationFrame(() => {
          if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
          }
        });
      },
    });

    return () => {
      lightbox.destroy();
    };
  }, [props.data]);

  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="text-center">
          <h2 className="section-title mt-3">GALERIA</h2>
          <p>Um pouco mais sobre nós.</p>
        </div>

        <div className="row g-2">
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className="col-sm-6 col-md-4 col-lg-4"
                >
                  <Image
                    title={d.title}
                    largeImage={d.largeImage}
                    smallImage={d.smallImage}
                  />
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
